// // ProfesorRecuperaciones.jsx
// import React, { useEffect, useState, useMemo } from "react";
// import axios from "axios";
// import { useAuth } from "../context/AuthContext";
// import '../style/ProfesorRecuperaciones.css';

// const API = "http://3.236.217.225:5001/api";

// const ProfesorRecuperaciones = () => {
//   const { token } = useAuth();

//   // Axios con token dinámico
//   const axiosAuth = useMemo(() => {
//     const instance = axios.create({ baseURL: API });
//     instance.interceptors.request.use(
//       (config) => {
//         if (token) config.headers.Authorization = `Bearer ${token}`;
//         return config;
//       },
//       (error) => Promise.reject(error)
//     );
//     return instance;
//   }, [token]);

//   // Estados
//   const [anios, setAnios] = useState([]);
//   const [periodos, setPeriodos] = useState([]);
//   const [asignaciones, setAsignaciones] = useState([]);
//   const [grados, setGrados] = useState([]);
//   const [grupos, setGrupos] = useState([]);
//   const [anioLectivoId, setAnioLectivoId] = useState("");
//   const [periodoId, setPeriodoId] = useState("");
//   const [grado, setGrado] = useState("");
//   const [grupo, setGrupo] = useState("");
//   const [asignacionId, setAsignacionId] = useState("");
//   const [pendientes, setPendientes] = useState([]);
//   const [notas, setNotas] = useState({});
//   const [loading, setLoading] = useState(false);

//   // Cargar año activo y asignaciones
//   useEffect(() => {
//     const cargarInicial = async () => {
//       try {
//         const [anioRes, asignacionesRes] = await Promise.all([
//           axiosAuth.get("/recuperaciones/anio-activo"),
//           axiosAuth.get("/recuperaciones/asignaciones"),
//         ]);
//         if (anioRes.data) {
//           setAnios([anioRes.data]);
//           setAnioLectivoId(anioRes.data.id);
//         }
//         setAsignaciones(asignacionesRes.data || []);
//       } catch (error) {
//         console.error("Error carga inicial:", error);
//       }
//     };
//     cargarInicial();
//   }, [axiosAuth]);

//   // Cargar periodos al cambiar año
//   useEffect(() => {
//     if (!anioLectivoId) return;
//     setPeriodoId("");
//     setPendientes([]);
//     axiosAuth
//       .get("/recuperaciones/periodos", { params: { anio_lectivo_id: Number(anioLectivoId) } })
//       .then((res) => setPeriodos(res.data || []))
//       .catch((err) => console.error(err));
//   }, [anioLectivoId, axiosAuth]);

//   // Filtrar grados y grupos
//   useEffect(() => setGrados([...new Set(asignaciones.map((a) => a.grado))]), [asignaciones]);
//   useEffect(() => {
//     if (!grado) {
//       setGrupo("");
//       setGrupos([]);
//       setAsignacionId("");
//       return;
//     }
//     const gruposUnicos = [...new Set(asignaciones.filter((a) => a.grado === grado).map((a) => a.grupo))];
//     setGrupo("");
//     setAsignacionId("");
//     setGrupos(gruposUnicos);
//   }, [grado, asignaciones]);

//   const materiasFiltradas = useMemo(() => {
//     if (!grado || !grupo) return [];
//     return asignaciones.filter((a) => a.grado === grado && a.grupo === grupo);
//   }, [asignaciones, grado, grupo]);

//   // Cargar estudiantes pendientes
//   const cargarPendientes = async () => {
//     if (!periodoId || !grado || !grupo || !asignacionId) return alert("Complete todos los filtros");
//     setLoading(true);
//     try {
//       const res = await axiosAuth.get("/recuperaciones/pendientes", {
//         params: { asignacion_id: Number(asignacionId), periodo_id: Number(periodoId) },
//       });
//       setPendientes(res.data || []);
//       setNotas({});
//     } catch (error) {
//       console.error("Error cargando pendientes:", error);
//       alert(error.response?.data?.msg || "Error cargando estudiantes pendientes");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Cambiar nota en input
//   const handleNotaChange = (notaId, value) => setNotas((prev) => ({ ...prev, [notaId]: value }));

//   // Guardar nota individual y actualizar columna nota_final
//   const guardarRecuperacion = async (notaId) => {
//     const nota = notas[notaId];
//     if (nota === undefined || nota === "") return alert("Ingrese una nota");
//     try {
//       await axiosAuth.post("/recuperaciones", { nota_id: Number(notaId), nota_recuperacion: Number(nota) });

//       // Actualizar nota_final en tabla local
//       setPendientes((prev) =>
//         prev.map((est) =>
//           est.nota_id === notaId
//             ? { ...est, nota_final: Number(nota), desempeño: Number(nota) >= 3 ? "Aprobado" : "Reprobado" }
//             : est
//         )
//       );
//       setNotas((prev) => ({ ...prev, [notaId]: "" }));
//       alert("Recuperación guardada correctamente");
//     } catch (error) {
//       console.error("Error guardando recuperación:", error);
//       alert(error.response?.data?.msg || "Error guardando recuperación");
//     }
//   };

//   // Guardar todas las notas y actualizar tabla
//   const guardarTodo = async () => {
//     const notasArray = pendientes
//       .filter((est) => notas[est.nota_id] !== undefined && notas[est.nota_id] !== "")
//       .map((est) => ({ nota_id: est.nota_id, nota_recuperacion: Number(notas[est.nota_id]) }));
//     if (notasArray.length === 0) return alert("No hay notas para guardar");

//     setLoading(true);
//     try {
//       await axiosAuth.post("/recuperaciones/guardar-todo", { notas: notasArray });

//       // Actualizar todas las notas finales en la tabla local
//       setPendientes((prev) =>
//         prev.map((est) => {
//           const nuevaNota = notasArray.find((n) => n.nota_id === est.nota_id);
//           if (nuevaNota) return { ...est, nota_final: nuevaNota.nota_recuperacion, desempeño: nuevaNota.nota_recuperacion >= 3 ? "Aprobado" : "Reprobado" };
//           return est;
//         })
//       );

//       setNotas({});
//       alert("Todas las recuperaciones se guardaron correctamente");
//     } catch (error) {
//       console.error("Error guardando todas las recuperaciones:", error);
//       alert(error.response?.data?.msg || "Error guardando las recuperaciones");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="card">
//       <h2>📘 Módulo de Recuperaciones</h2>

//       <div className="filtros">
//         <select value={anioLectivoId} onChange={(e) => setAnioLectivoId(e.target.value)}>
//           <option value="">Seleccione Año</option>
//           {anios.map((a) => (<option key={a.id} value={a.id}>{a.anio} {a.activo === 1 ? "(Activo)" : ""}</option>))}
//         </select>

//         <select value={periodoId} onChange={(e) => setPeriodoId(e.target.value)}>
//           <option value="">Seleccione Periodo</option>
//           {periodos.map((p) => (<option key={p.id} value={p.id}>{p.nombre}</option>))}
//         </select>

//         <select value={grado} onChange={(e) => setGrado(e.target.value)}>
//           <option value="">Seleccione Grado</option>
//           {grados.map((g, i) => (<option key={i} value={g}>{g}</option>))}
//         </select>

//         <select value={grupo} onChange={(e) => setGrupo(e.target.value)}>
//           <option value="">Seleccione Grupo</option>
//           {grupos.map((g, i) => (<option key={i} value={g}>{g}</option>))}
//         </select>

//         <select value={asignacionId} onChange={(e) => setAsignacionId(e.target.value)}>
//           <option value="">Seleccione Materia</option>
//           {materiasFiltradas.map((m) => (<option key={m.asignacion_id} value={m.asignacion_id}>{m.materia_nombre}</option>))}
//         </select>

//         <button onClick={cargarPendientes}>Buscar</button>
//       </div>

//       {loading ? (
//         <p>Cargando...</p>
//       ) : (
//         <>
//           <table className="tabla-recuperaciones">
//             <thead>
//               <tr>
//                 <th>Estudiante</th>
//                 <th>Nota Final</th>
//                 <th>Nota Recuperación</th>
//                 <th>Acción</th>
//               </tr>
//             </thead>
//             <tbody>
//               {pendientes.length === 0 ? (
//                 <tr><td colSpan="4">No hay estudiantes pendientes</td></tr>
//               ) : pendientes.map((est) => (
//                 <tr key={est.nota_id} className={Number(est.nota_final) >= 3 ? "aprobado" : "reprobado"}>
//                   <td data-label="Estudiante">{est.nombres_estudiante} {est.apellidos_estudiante}</td>
//                   <td data-label="Nota Final">{Number(est.nota_final).toFixed(1)} - {est.desempeño}</td>
//                   <td data-label="Nota Recuperación">
//                     <input type="number" min="0" max="5" step="0.1"
//                       value={notas[est.nota_id] || ""}
//                       onChange={(e) => handleNotaChange(est.nota_id, e.target.value)}
//                     />
//                   </td>
//                   <td data-label="Acción">
//                     <button onClick={() => guardarRecuperacion(est.nota_id)}>Guardar</button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>

//           {pendientes.length > 0 && (
//             <button className="guardar-todo-btn" onClick={guardarTodo} disabled={loading}>Guardar Todo</button>
//           )}
//         </>
//       )}
//     </div>
//   );
// };

// export default ProfesorRecuperaciones;


import React, { useEffect, useState, useMemo, useCallback } from "react";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { API as BASE_URL } from "../components/config";
import "../style/ProfesorRecuperaciones.css";

const API_PATH = `${BASE_URL}/recuperaciones`;

const ProfesorRecuperaciones = () => {
  const { token, user } = useAuth();

  const [anios, setAnios] = useState([]);
  const [periodos, setPeriodos] = useState([]);
  const [asignaciones, setAsignaciones] = useState([]);
  const [grados, setGrados] = useState([]);
  const [grupos, setGrupos] = useState([]);

  const [pendientes, setPendientes] = useState([]);
  const [notas, setNotas] = useState({});
  const [loading, setLoading] = useState(false);

  const [filtros, setFiltros] = useState({
    anioLectivoId: "",
    periodoId: "",
    grado: "",
    grupo: "",
    asignacionId: "",
  });

  /* =========================
     AXIOS AUTH
  ========================= */
  const axiosAuth = useMemo(() => {
    const instance = axios.create({
      baseURL: API_PATH,
    });

    instance.interceptors.request.use((config) => {
      if (token) config.headers.Authorization = `Bearer ${token}`;

      config.headers["X-Tenant-ID"] =
        user?.institucion_id || user?.tenant_id || "";

      config.headers["X-Sede-ID"] = user?.sede_id || "";

      return config;
    });

    return instance;
  }, [token, user]);

  /* =========================
     CARGA INICIAL
  ========================= */
  const cargarInicial = useCallback(async () => {
    try {
      const [anioRes, asigRes] = await Promise.all([
        axiosAuth.get("/anio-activo"),
        axiosAuth.get("/asignaciones"),
      ]);

      const anio = anioRes.data;

      if (anio) {
        setAnios([anio]);
        setFiltros((f) => ({
          ...f,
          anioLectivoId: anio.id,
        }));
      }

      const asig = asigRes.data || [];

      setAsignaciones(asig);
      setGrados([...new Set(asig.map((a) => String(a.grado)))]);
    } catch (err) {
      console.error("Error inicial:", err);
    }
  }, [axiosAuth]);

  useEffect(() => {
    if (!token) return;
    cargarInicial();
  }, [token, cargarInicial]);

  /* =========================
     PERIODOS
  ========================= */
  useEffect(() => {
    if (!filtros.anioLectivoId) return;

    axiosAuth
      .get("/periodos", {
        params: { anio_lectivo_id: filtros.anioLectivoId },
      })
      .then((res) => setPeriodos(res.data || []))
      .catch(console.error);
  }, [filtros.anioLectivoId, axiosAuth]);

  /* =========================
     GRUPOS
  ========================= */
  useEffect(() => {
    if (!filtros.grado) {
      setGrupos([]);
      return;
    }

    const filtrados = asignaciones
      .filter((a) => String(a.grado) === String(filtros.grado))
      .map((a) => String(a.grupo));

    setGrupos([...new Set(filtrados)]);
  }, [filtros.grado, asignaciones]);

  /* =========================
     MATERIAS
  ========================= */
  const materiasFiltradas = useMemo(() => {
    if (!filtros.grado || !filtros.grupo) return [];

    return asignaciones.filter(
      (a) =>
        String(a.grado) === String(filtros.grado) &&
        String(a.grupo) === String(filtros.grupo)
    );
  }, [asignaciones, filtros.grado, filtros.grupo]);

  /* =========================
     FILTROS
  ========================= */
  const handleFiltroChange = (e) => {
    const { name, value } = e.target;

    setFiltros((prev) => {
      const nuevo = { ...prev, [name]: value };

      if (name === "grado") {
        nuevo.grupo = "";
        nuevo.asignacionId = "";
      }

      if (name === "grupo") {
        nuevo.asignacionId = "";
      }

      return nuevo;
    });

    setPendientes([]);
    setNotas({});
  };

  /* =========================
     BUSCAR
  ========================= */
  const cargarPendientes = async () => {
    const { periodoId, asignacionId } = filtros;

    if (!periodoId || !asignacionId) {
      return alert("Complete todos los filtros");
    }

    try {
      setLoading(true);

      const res = await axiosAuth.get("/pendientes", {
        params: {
          asignacion_id: asignacionId,
          periodo_id: periodoId,
        },
      });

      // 🔥 eliminar duplicados por nota_id
      const unique = [];
      const map = new Set();

      for (const item of res.data || []) {
        if (!map.has(item.nota_id)) {
          map.add(item.nota_id);
          unique.push(item);
        }
      }

      setPendientes(unique);
      setNotas({});
    } catch (err) {
      console.error(err);
      alert("Error cargando datos");
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     INPUT NOTAS (DINÁMICO 🔥)
  ========================= */
const handleNotaChange = (id, value, min, max) => {
  let v = value;

  if (v === "") {
    setNotas((prev) => ({ ...prev, [id]: "" }));
    return;
  }

  v = Number(v);

  if (isNaN(v)) return;

  // ⚠️ validación dinámica por tenant
  if (min !== null && v < Number(min)) v = Number(min);
  if (max !== null && v > Number(max)) v = Number(max);

  setNotas((prev) => ({
    ...prev,
    [id]: v,
  }));
};


  /* =========================
     GUARDAR
  ========================= */
  const guardarTodo = async () => {
    const payload = pendientes
      .filter((p) => notas[p.nota_id] !== "" && notas[p.nota_id] !== undefined)
      .map((p) => ({
        nota_id: p.nota_id,
        nota_recuperacion: parseFloat(notas[p.nota_id]),
      }));

    if (!payload.length) {
      return alert("No hay cambios para guardar");
    }

    try {
      setLoading(true);

      await axiosAuth.post("/guardar-todo", {
        notas: payload,
      });

      alert("Guardado correctamente");
      await cargarPendientes();
    } catch (err) {
      console.error(err);
      alert("Error guardando");
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     UI
  ========================= */
  return (
    <div className="recuperaciones-root fade-in">
      <h2>📘 Recuperaciones Académicas</h2>

      <div className="filtros-grid-rec">

        <select name="anioLectivoId" value={filtros.anioLectivoId} onChange={handleFiltroChange}>
          {anios.map((a) => (
            <option key={`anio-${a.id}`} value={a.id}>
              {a.anio}
            </option>
          ))}
        </select>

        <select name="periodoId" value={filtros.periodoId} onChange={handleFiltroChange}>
          <option value="">Periodo</option>
          {periodos.map((p) => (
            <option key={`periodo-${p.id}`} value={p.id}>
              {p.nombre}
            </option>
          ))}
        </select>

        <select name="grado" value={filtros.grado} onChange={handleFiltroChange}>
          <option value="">Grado</option>
          {grados.map((g, i) => (
            <option key={`grado-${g}-${i}`} value={g}>
              {g}
            </option>
          ))}
        </select>

        <select name="grupo" value={filtros.grupo} onChange={handleFiltroChange}>
          <option value="">Grupo</option>
          {grupos.map((g, i) => (
            <option key={`grupo-${g}-${i}`} value={g}>
              {g}
            </option>
          ))}
        </select>

        <select name="asignacionId" value={filtros.asignacionId} onChange={handleFiltroChange}>
          <option value="">Materia</option>
          {materiasFiltradas.map((m, i) => (
            <option key={`asig-${m.asignacion_id}-${i}`} value={m.asignacion_id}>
              {m.materia_nombre}
            </option>
          ))}
        </select>

        <button onClick={cargarPendientes} disabled={loading}>
          {loading ? "Consultando..." : "Buscar"}
        </button>
      </div>

      <table>
        <thead>
          <tr>
            <th>Estudiante</th>
            <th>Nota Actual</th>
            <th>Mínima</th>
            <th>Recuperación</th>
          </tr>
        </thead>

        <tbody>
          {pendientes.length === 0 ? (
            <tr>
              <td colSpan="4">Sin datos</td>
            </tr>
          ) : (
            pendientes.map((p) => (
              <tr key={`row-${p.nota_id}`}>
                <td>
                  {p.apellidos_estudiante} {p.nombres_estudiante}
                </td>

                <td>{Number(p.nota_final || 0).toFixed(2)}</td>

                <td>{Number(p.nota_minima || 0).toFixed(2)}</td>

                <td>
                  <input
  type="number"
  step="any"
  value={notas[p.nota_id] ?? ""}
  onChange={(e) =>
    handleNotaChange(
      p.nota_id,
      e.target.value,
      p.escala_min,
      p.escala_max
    )
  }
/>

                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {pendientes.length > 0 && (
        <button onClick={guardarTodo} disabled={loading}>
          {loading ? "Guardando..." : "Guardar Todo"}
        </button>
      )}
    </div>
  );
};

export default ProfesorRecuperaciones;
